<template>
  <div class="edit-focus">
    <div class="d-flex justify-content-between align-items-center">
      <h2 class="title">Edit Destination</h2>
      <div class="ico" @click="$emit('CloseMe')">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
            fill="#474D52"
          />
        </svg>
      </div>
    </div>
    <div class="prefix-textarea mt-24">
      <span class="prefix"> <label for="first">I shall</label></span>
      <input type="text" v-model="updatedFocus.ishall" rows="2" id="first" />
    </div>
    <div class="prefix-textarea">
      <span class="prefix"><label for="second">so that</label></span
      ><textarea v-model="updatedFocus.sothat" rows="2" id="second"></textarea>
    </div>
    <button
      class="btn btn-primary btn-sm collapsed"
      @click="$emit('updateFocus', updatedFocus)"
    >
      Update
    </button>
  </div>
</template>

<script>
export default {
  props: {
    focus: Object
  },
  data() {
    return {
      updatedFocus: {
        ishall: this.focus.destination.text1,
        sothat: this.focus.destination.text2
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.mt-24 {
  margin-top: 24px;
  margin-bottom: 14px;
}
.edit-focus {
  padding: 24px;
  position: relative;
  .title {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 22px;
    color: #474d52;
    margin: 0;
  }
}
.prefix-textarea {
  position: relative;
  .prefix {
    font-style: normal;
    font-size: 16px;
    line-height: 22px;
    // padding-left: 10px;
    color: #cbcbcb;
    position: absolute;
    background-color: #fff;
  }
  input,
  textarea {
    border-radius: 0;
    width: 100%;
    height: unset;
    text-indent: 62px;
    font-size: 16px;
    line-height: 22px;
    resize: none;
    color: #5b606c;
    border: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
}

.btn.collapsed {
  padding: 11px;
  width: 100%;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
  color: #ffffff;
  border-radius: 8px;
  margin-top: 23px;
}
h1 {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: #8d99a0;
  text-align: center;
}
</style>
